'use strict';//Indicating browser should run only in java script mode


angular.module('EMR.Home').service('BillingCommonservice', ['CommonService', 'CommonPostService',function (CommonService, CommonPostService) {

	//################### GET BILLING CHARGE CPATURE LINKED MODULES LIST BLOCK START  #############################
	///*******PURPOSE: METHOD TO GET BILLING CHARGE CPATURE LINKED MODULES LIST         
	///*******CREATED BY: Pavan B
	///*******CREATED DATE: 05/18/2017
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.GetBillingChargeCpatureLinkedModulesList = function (postData) {
		if (!hasValue(postData)) postData = {};
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonService.PostData('POST', CommonService.EHR_ChargeCapture_TriggerCustomization() + "GetBillingChargeCpatureLinkedModulesList", postData).then(function (result) { return result; });
	};
	//################### GET BILLING CHARGE CPATURE NOT LINKED MODULES LIST BLOCK END  #############################

	//################### GET BILLING CHARGE CPATURE APPOINTMENT MODULE CANCELLATION SUB CUSTOMIZATION LIST BLOCK START  #############################
	///*******PURPOSE: METHOD GET BILLING CHARGE CPATURE APPOINTMENT MODULE CANCELLATION SUB CUSTOMIZATION
	///*******CREATED BY: Sanjay I
	///*******CREATED DATE: 02/11/2019
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
	this.GetBillingCCApptCancellationSubCustomizationList = function (postData) {
		if (!hasValue(postData)) postData = {};
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonService.PostData('POST', CommonService.EHR_ChargeCapture_TriggerCustomization() + "GetBillingCCApptCancellationTriggerCustomizationInfo", postData).then(function (result) { return result; });
	};
	//################### GET BILLING CHARGE CPATURE APPOINTMENT MODULE CANCELLATION SUB CUSTOMIZATION LIST BLOCK END  #############################

	//########################## METHOD TO GET REJECTED AND ACKNOWLEDGED RECORDS INFORMATION IE. 277 AND 999 FILES COUNT. - START ###########################
	//*******PURPOSE: THIS METHOD IS USED TO GET REJECTED AND ACKNOWLEDGED RECORDS INFORMATION IE. 277 AND 999 FILES COUNT.
	//*******CREATED BY: S.SUDHEER
	//*******CREATED DATE: 09/12/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
	this.billingDashboardGet277and999FilesCount = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		// postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
		//return CommonService.PostData('POST', CommonService.EMRPracticeManagement_Billing() + "Get277and999FilesCount", postData).then(function (result) { return result; });
        return CommonService.PostData('POST', CommonService.Billing_277ACK_277RejectionManagement() + "Get277and999FilesCount", postData).then(function (result) { return result; });

	};
	//########################## METHOD TO VALIDATE CLAIM INFORMATION - START ###########################
	/**@function inboxMenuGetPortalPaymentsCount
	 * @author V S K Rambabu. V
	 * @since 05112021
	 * @purpose Service call to get the count of Payments from portal
	 */
	this.inboxMenuGetPortalPaymentsCount = function (inputData) {
		inputData.practicemodel = EMRPracticeModel;
		inputData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_ApplyPayements() + "InboxMenuGetPortalPaymentsCount", inputData).then(function (result) { return result; });
	};

}]);